import { useGetPaymentFees } from '@/apis/payments/hooks/useGetPaymentFees'
import { Category } from '@/apis/providers/types/provider.types'
import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import ExpenseAllocationForm from '@/app/pages/providers/pages/expense_allocation/expense_allocation_form'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useSelector } from 'react-redux'

type Props = {
  onNext: (categories: Category[]) => void
  defaultValues: Category[]
  amount: number
}

function ReimbursementsAllocateCategoriesPage(props: Props) {
  const { onNext, defaultValues, amount } = props
  const programId = useSelector(selectProgramID)

  function handleFormSuccess(data: Category[]) {
    onNext(data)
  }

  const serviceFeeQuery = useGetPaymentFees({
    base_amount: amount,
    program_id: programId,
  })

  return (
    <div>
      <PageLoader query={serviceFeeQuery}>
        {(serviceFee) => {
          function automaticallyAllocateFullAmountIfOnlyOneCategory() {
            if (defaultValues.length === 1) {
              const category = defaultValues[0]
              const updatedCategory = {
                ...category,
                amount: amount,
              }
              return [updatedCategory]
            }
            return defaultValues
          }
          return (
            <ExpenseAllocationForm
              serviceFee={serviceFee}
              defaultValues={automaticallyAllocateFullAmountIfOnlyOneCategory()}
              onSuccess={handleFormSuccess}
              paymentAmount={amount}
            />
          )
        }}
      </PageLoader>
    </div>
  )
}

export default ReimbursementsAllocateCategoriesPage
